<template>
  <el-button
      v-bind="$attrs"
      :disabled="!table || $attrs.disabled"
      :loading="loading"
      @click="handleExport"
  >
    {{ label }}
  </el-button>
</template>

<script>
import { ElMessage } from 'element-plus';
import * as XLSX from 'xlsx'; // 需要安装: npm install xlsx

export default {
  name: 'ExportTableButton',
  inheritAttrs: false,
  props: {
    // 表格实例引用
    table: {
      type: Object,
      required: true,
      default: null
    },
    // 按钮文字
    label: {
      type: String,
      default: '导出表格'
    },
    // 默认文件名
    defaultFileName: {
      type: String,
      default: '表格数据.xlsx'
    },
    // Sheet名称
    sheetName: {
      type: String,
      default: '数据'
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async handleExport() {
      // 1. 基础校验
      if (!this.table) {
        ElMessage.error('未提供有效的表格实例');
        return;
      }

      const data = this.table.data || [];
      if (data.length === 0) {
        ElMessage.warning('没有可导出的数据！');
        return;
      }

      this.loading = true;

      const hearMap = {
        "序号": "ImpNum",
        "阻抗类型": "Imp_Type_",
        "控制层": "Imp_ControlLay_",
        "上参考层": "Imp_UpLay_",
        "下参考层": "Imp_DownLay_",
        "线宽": "Imp_LineWidth_",
        "线距": "Imp_LineSpace_",
        "线到铜距离": "Imp_LineCuSpace_",
        "阻抗要求": "Imp_Value_Req_",
        "阻抗公差": "Imp_Value_Tol_",
      }

      try {
        // 2. 准备数据 (通用逻辑，类似 CopyTableButton)
        // 获取有效列 (有 property 的列，或者你自己定义需要导出的列类型)
        const columns = this.table.columns.filter(col => col.property || col.type === 'index');

        if (!columns.length) {
          throw new Error('表格没有有效的列定义');
        }

        // 提取表头
        const headers = columns.map(col => col.label || '');
        const props = columns.map(col => col.property);

        // 提取数据行 (转换为二维数组 Array of Arrays)
        const dataRows = data.map((row, index) => {
          return columns.map(col => {
            //如果是索引列
            if (col.type === 'index') {
              return index + 1;
            }
            // 获取对应字段的值
            const prop = col.property;
            const value = row[prop];
            // 简单的空值处理，如果需要格式化（如日期/字典映射），可以在这里扩展逻辑
            return (value === null || value === undefined) ? '' : String(value);
          });
        });

        // 组合 Excel 数据: [表头, ...数据]
        const mapHeards = headers.map(col => {
          if (hearMap[col]) {
            return hearMap[col];
          }else {
            return ""
          }
        })
        const excelData = [headers, mapHeards, ...dataRows];

        // 3. 创建工作簿对象
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // 添加 Sheet
        XLSX.utils.book_append_sheet(wb, ws, this.sheetName);

        // 4. 生成二进制数据
        // bookType: 'xlsx', type: 'array' 是必须的，以便传输给 Electron
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        // 5. 获取上次导出的路径记录
        const lastExportPath = localStorage.getItem('LAST_EXPORT_PATH');

        // 6. 调用 Electron 保存 (前提：window.electronAPI 已注入)
        if (!window.electronAPI || !window.electronAPI.saveExcelFile) {
          throw new Error('未检测到 Electron 环境或 saveExcelFile API');
        }

        const result = await window.electronAPI.saveExcelFile({
          buffer: wbout,
          defaultName: this.defaultFileName,
          lastPath: lastExportPath
        });

        // 7. 处理结果
        if (result.success) {
          // 保存成功后，更新“导出路径”记录
          if (result.savedDir) {
            localStorage.setItem('LAST_EXPORT_PATH', result.savedDir);
          }
          ElMessage.success('导出成功！文件已保存。');
        } else if (result.status === 'canceled') {
          ElMessage.info('用户取消导出');
        } else {
          ElMessage.error('导出失败：' + result.error);
        }

      } catch (err) {
        console.error('导出异常:', err);
        ElMessage.error(err.message || '导出过程中发生错误');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>